import React, { Fragment, useEffect } from 'react'
import { useAuth } from "hooks/use-auth";
import { useForm, SubmitHandler } from "react-hook-form";
import config from 'config';
import { formatMobileNumberCountryCodeToJapanese } from 'utils';
import { Wrapper, FormLabel, FormInput, FormLabelInputWrapper, ModalSubmit, Title, IconWrapper, DeleteUserButton, DivFlex } from 'styles/styles';
import { Delete } from '@mui/icons-material';

interface CognitoMailDataProps {
	phoneNumber: string
}


export const CognitoSetSMS = () => {
	const auth = useAuth();
	useEffect(() => {
		setValue('phoneNumber', formatMobileNumberCountryCodeToJapanese(auth.phoneNumber));
	}, [auth]);

	const [phoneNumber, setPhoneNumber] = React.useState('');

	//modal
	const { reset, register, handleSubmit, watch, setValue, formState: { errors } } = useForm<CognitoMailDataProps>();
	const onSubmit: SubmitHandler<CognitoMailDataProps> = async (submitData: CognitoMailDataProps) => {
		const res = await auth.submitPhoneNumber(submitData.phoneNumber);
		setPhoneNumber(submitData.phoneNumber)
		window.alert(res.message);
	}
	//modal end

	//arrayの生成
	const parentArray = [
		{ title: '2段階認証用電話番号', field: 'phoneNumber', type: 'tel', required: true }]

	const listItems = parentArray.map((element: any, index) => {
		if (element.title) {
			return (
				<Fragment key={index}>
					<FormLabelInputWrapper>
						<FormLabel htmlFor={element.field}>{element.title}</FormLabel>
						<FormInput {...register(element.field)}
							{...(element.type && { type: config.inputErrorMessage[element.type].type })}
							{...(element.type && { placeholder: config.inputErrorMessage[element.type].placeholder })}
							{...(element.type && { pattern: config.inputErrorMessage[element.type].pattern })}
							{...(element.type && { title: config.inputErrorMessage[element.type].title })}
							{...(element.required && { required: true })}
							{...(element.disable && { disabled: true })}
							{...(element.type && { maxLength: config.inputErrorMessage[element.type].maxLength })}
							{...(element.type === "number" && { max: config.inputErrorMessage[element.type].max })}
						/>
						{auth.isSetMFA ? <IconWrapper><Delete onClick={() => mfaDisable()} /></IconWrapper> : <></>}
					</FormLabelInputWrapper>
				</Fragment>
			)
		}
	});

	const mfaDisable = async () => {
		const res = await auth.disableMFA();
		window.alert(res.message);
	}

	if (auth.waitingForPhoneNumberAttributeVerificationCodeInput) {
		return <PhoneNumberConfirmForm phoneNumber={phoneNumber} />;
	}

	return (
		<>
			<form onSubmit={handleSubmit(onSubmit)}>
				{listItems}
				{auth.isSetMFA ? "" : <ModalSubmit type="submit" value={"認証して登録する"} />}
			</form>
		</>
	)
}


const PhoneNumberConfirmForm = ({ phoneNumber }: { phoneNumber: string }) => {
	interface Inputs {
		verificationCode: string,
	};

	const auth = useAuth();
	const { register, handleSubmit, watch, formState: { errors } } = useForm<Inputs>();

	const onSubmit: SubmitHandler<Inputs> = async data => {
		const res = await auth.confirmPhoneNumberAttributeSubmit(data.verificationCode);
		window.alert(res.message);
	};

	const cancelSubmit = async () => {
		const res: any = auth.cancelMFA();
		window.alert(res.message);
	}

	return (
		<>
			<form onSubmit={handleSubmit(onSubmit)}>
				<Wrapper>
					<Title>電話認証コード入力</Title>
					<DivFlex><strong>{phoneNumber}</strong>に認証コードを送信しました。<DeleteUserButton onClick={cancelSubmit}>キャンセル</DeleteUserButton></DivFlex>
					<FormLabelInputWrapper>
						<FormLabel htmlFor="verificationCode">電話認証コード:</FormLabel>
						<FormInput {...register("verificationCode")} type="verificationCode" id="verificationCode" name="verificationCode" required
							onKeyDown={(e) => {
								if (e.key === "Enter") {
									e.preventDefault();
								}
							}} />
					</FormLabelInputWrapper>
					<ModalSubmit type="submit" />
				</Wrapper>
			</form>
		</>
	)
}